<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-full lg:w-5/6 xl:w-2/3">
			<vx-card>
				<div class="flex mb-8">
					<router-link v-if="$route.query.mt" :to="`/bayar-zis/choose-payment?ft=${ $route.query.ft ? $route.query.ft : 1 }&amount=${ $route.query.amount ? $route.query.amount : 0 }&t=${ $route.query.t ? $route.query.t : 'zakat' }&mt=${$route.query.mt}`">
						<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
					</router-link>
          <router-link v-else :to="`/bayar-zis/choose-payment?amount=${ $route.query.amount ? $route.query.amount : 0 }&t=${ $route.query.t ? $route.query.t : 'zakat' }`">
            <feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
          </router-link>
					<strong class="text-primary"><small>Konfirmasi Pembayaran</small></strong>
				</div>

				<div class="flex justify-center mb-12">
					<img src="/assets/images/topup/confirm.svg" alt="" class="md:w-1/4 w-1/6" />
				</div>
				<section class="vx-row justify-center mb-24">
					<div class="vx-col lg:w-5/6 xl:w-2/3">
            <table class="w-full" v-if="transactionProduct.mt !== null && sahabat_name !== null">
              <tr>
                <td class="text-left">
                  <strong class="text-dark">Sahabat ZX</strong>
                </td>
                <td class="text-right">
                  <strong class="text-grey">{{ sahabat_name }}</strong>
                </td>
              </tr>
            </table>
						<table class="w-full">
							<tr>
								<td class="text-left">
									<strong class="text-dark">Transaksi</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">{{ transactionProduct.name}}</strong>
								</td>
							</tr>
						</table>
						<vs-divider class="my-4"></vs-divider>
						<table class="w-full">
							<tr>
								<td class="text-left">
									<strong class="text-dark">Metode Pembayaran</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">{{ transactionPayment.name }}</strong>
								</td>
							</tr>
						</table>
						<vs-divider class="my-4"></vs-divider>
						<table class="w-full">
							<tr>
								<td class="text-left">
									<strong class="text-dark">Total Pembayaran</strong>
								</td>
								<td class="text-right">
									<strong class="text-dark">Rp {{ formatRupiah(transactionProduct.jumlah_bayar) }}</strong>
								</td>
							</tr>
						</table>
            <!-- Detail Name -->
            <vs-collapse v-if="profile">
              <vs-collapse-item>
                <div slot="header">
                  <small>Info Donatur (opsional)</small>
                </div>
                <form>
                  <p class="mb-2"><strong>Nama</strong></p>
                  <vs-input 
                    v-if="isZafit"
                    class="w-full rounded-lg mb-4"
                    v-model="name"
                    disabled
                  />
                  <vs-input 
                    v-else
                    class="w-full rounded-lg mb-4"
                    v-model="name"
                  />
                  <p class="mb-2"><strong>Email</strong></p>
                  <span v-if="errors.has('email')" class="block text-danger text-sm py-2">{{ errors.first('email') }}</span>
                  <vs-input 
                    class="w-full rounded-lg mb-4"
                    v-validate="'required|email'"
                    v-model="email"
                    name="email"
                  />
                  <p class="mb-2"><strong>No. Telepon</strong></p>
                  <span v-if="errors.has('no_telp')" class="block text-danger text-sm py-2">{{ errors.first('no_telp') }}</span>
                  <vs-input 
                    v-validate="'required|min:10|max:13'"
                    class="w-full rounded-lg mb-4"
                    v-model="no_telp"
                    name="no_telp"
                    type="number"
                  />
                  
                  <br>
                </form>
              </vs-collapse-item>
            </vs-collapse>
            <form v-else>
              <p class="mb-2"><strong>Nama</strong></p>
              <vs-input 
                class="w-full rounded-lg mb-4"
                v-model="name"
                name="name"
                v-validate="'required'"
                :danger="errors.has('name')"
              />
              <span v-if="errors.has('name')" class="text-small text-danger">
                {{ errors.first('name') }}
              </span>
              <p class="mb-2"><strong>Email</strong></p>
              <vs-input
                class="w-full rounded-lg mb-4"
                v-model="email"
                name="email"
                v-validate="'required|email'"
                :danger="errors.has('email')"
              />
              <span v-if="errors.has('email')" class="text-small text-danger">
                {{ errors.first('email') }}
              </span>
              <p class="mb-2"><strong>No. Telepon</strong></p>
              <vs-input
                type="number"
                class="w-full rounded-lg mb-4"
                v-model="no_telp"
                name="no_telp"
                v-validate="'required|min:10|max:13'"
                :danger="errors.has('no_telp')"
              />
              <span v-if="errors.has('no_telp')" class="text-small text-danger">
                {{ errors.first('no_telp') }}
              </span>
            </form>
            <!-- / -->
            <!-- Doa -->
            <div class="mb-4">
              <strong class="mb-2">Doa (opsional)</strong>
              <vs-textarea class="w-full rounded-lg" v-model="doa" />
            </div>
            <!-- / -->

            <!-- Is Anonymous donatur -->
            <div class="flex items-center mb-4">
              <vs-checkbox v-model="status_hide" class="mr-3" />
              <strong>Sembunyikan nama saya</strong>
            </div>
            <!-- / -->
					</div>
				</section>

				<vs-button class="py-4 w-full" @click.prevent="postTransaction">
					<strong class="text-white">Bayar</strong>
				</vs-button>
			</vx-card>
		</div>

    <!-- Modal Verify Pin -->
    <vs-popup 
      fullscreen 
      title="Verifikasi PIN Saldo" 
      :active.sync="popupPinSaldo">
        
        <pin-form 
          layoutClass="mx-auto w-full vx-row justify-center w-full md:w-1/2 mb-12"
          @authPin="authPin" 
        >
          <template v-slot:header>
            <h3 class="text-primary mb-6 text-center">
              <strong>
                Verifikasi PIN Saldo Anda
              </strong>
            </h3>
          </template>
        </pin-form>

    </vs-popup>
    <!-- / -->
	</section>
</template>
<script>
import { transactionStatus } from '@/assets/utils/transaction'
import { mapGetters, mapState } from 'vuex'
import { Validator } from 'vee-validate'

const dict = {
  custom: {
    name: {
      required: 'Harap masukan nama lengkap anda'
    },
    email: {
      required: 'Harap masukan email anda',
      email: 'Harap masukan email yang valid'
    },
    no_telp: {
      required: 'Harap masukan no telepon anda',
      min: 'Minimal nomer telepon 10 digit',
      max: 'Maksimal nomer telepon 13 digit'
    }
  }
};

Validator.localize('en', dict);

export default {
  components: {
    PinForm: () => import('@/views/components/PinForm.vue')
  },
  data: () => ({
    popupPinSaldo: false,
    name: null,
    isZafit: false,
    email: null,
    no_telp: null,
    alamat: null,
    status_hide: false,
    doa: null,
    product: {},
    payment: {},
    jenis: [],
    sahabat: null,
    sahabat_name: null,
    fitur_id: null,
    transactionProduct: {},
    transactionPayment: {},
    payload: {}
  }),
  computed: {
    zisStatus () {
      return transactionStatus.find(it => it.name === this.type)
    },
    type () {
      return this.$route.query.t ? this.$route.query.t : 'zakat'
    },
    ...mapGetters('auth', ['profile']),
    ...mapState('mitra', ['choiceMitra'])
  },
  methods: {
    authPin() {
      const isCorrect = true
      if(isCorrect) {
        this.$vs.loading()
        this.popupPinSaldo = false
        this.$store.dispatch(`${this.type}/makeTransaction`, [this.payload])
          .then(() => {
            
            this.$vs.loading.close()

            // Delete state payment and product
            this.$store.dispatch(`${this.type}/deleteTransactionProduct`)
            this.$store.dispatch(`${this.type}/deleteTransactionPayment`)
            this.$store.dispatch(`${this.type}/deleteTransactionAmount`)
            this.$store.dispatch(`${this.type}/deleteTransactionTypes`)

            setTimeout(() => {
              if( this.$route.query.mt ) {
                  this.$router.push(`/bayar-zis/complete?t=${this.type}&mt=${this.$route.query.mt}`)
              }
              else {
                this.$router.push(`/bayar-zis/complete?t=${this.type}`)
              }
            }, 1000)
              
          })
          .catch(e => {
            this.$vs.loading.close()
            if (e.response) {
              console.error(e.response)
              this.$vs.notify({
                title: 'Oops',
                text: e.response.data.message,
                color: 'warning',
                position: 'top-right'
              })
            }

            return false
          })
      }
      else {
        this.$vs.notify({
          title: 'PIN Saldo Salah',
          text: '',
          color: 'danger',
          position: 'top-right'
        })

        return false
      }
    },
    postTransaction () {
      this.$validator.validateAll().then(res => {
        if(res) {
          Object.assign(this.product, this.transactionProduct)
          Object.assign(this.payment, this.transactionPayment)
          const jenis = this.jenis.find(it => it.name.toLowerCase().split(' ').join('_') === this.$route.query.t)
          const jenis_id = jenis ? jenis.id : 1,
                success_url = process.env.VUE_APP_FE ? process.env.VUE_APP_FE : 'https://dev.zax.co.id',
                failed_url = process.env.VUE_APP_FE ? process.env.VUE_APP_FE : 'https://dev.zax.co.id'
          const status_hide = this.status_hide ? 1 : 0

          if(this.profile) {
              this.payload = {
                user_id: this.profile.id,
                metode_id: this.payment.id,
                jenis_id,
                fitur_id: this.fitur_id,
                zakat: this.$route.query.ft,
                jumlah_bayar: this.product.jumlah_bayar,
                success_url,
                failed_url,
                name: this.name,
                deskripsi: this.product.description,
                email: this.email,
                no_telp: this.no_telp,
                status_hide,
                doa: this.doa
              }
          }
          else {
            this.payload = {
              metode_id: this.payment.id,
              jenis_id,
              fitur_id: this.fitur_id,
              zakat: this.$route.query.ft,
              jumlah_bayar: this.product.jumlah_bayar,
              success_url,
              failed_url,
              name: this.name,
              alamat: this.alamat,
              deskripsi: this.product.description,
              email: this.email,
              no_telp: this.no_telp,
              status_hide,
              doa: this.doa
            }
          }

          if( this.$route.query.mt && this.sahabat !== null) {
            this.payload.mitra_id = this.sahabat.user.id
          }

          if( this.$route.query.ref ) {
            this.payload.referal = this.$route.query.ref
          }

          // check if using saldo, show popup
          if(this.payment.code === 'saldo') {
            this.popupPinSaldo = true
          }
          else {
            this.$vs.loading()
            this.$store.dispatch(`${this.type}/makeTransaction`, [this.payload])
              .then(() => {
                this.$vs.loading.close()
                // Delete state payment and product
                this.$store.dispatch(`${this.type}/deleteTransactionProduct`)
                this.$store.dispatch(`${this.type}/deleteTransactionPayment`)
                this.$store.dispatch(`${this.type}/deleteTransactionAmount`)
                this.$store.dispatch(`${this.type}/deleteTransactionTypes`)

                if( this.$route.query.mt ) {
                  this.$router.push(`/bayar-zis/complete?t=${this.type}&mt=${this.$route.query.mt}`)
                }
                else {
                  this.$router.push(`/bayar-zis/complete?t=${this.type}`)
                }
              })
              .catch(e => {
                this.$vs.loading.close()
                if (e.response) {
                  console.error(e.response)
                  this.$vs.notify({
                    title: 'Oops',
                    text: e.response.data.message,
                    color: 'warning',
                    position: 'top-right'
                  })
                }

                return false
              })  
          }
        }
      })
        
    },
    getTypeTransaction () {
      this.$vs.loading()
      this.$store.dispatch(`${this.type}/getTypeTransaction`)
        .then(types => {
          this.$vs.loading.close()
          this.jenis = types
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)	
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    }
  },
  created () {
    if(!this.$route.query.ft) {
      this.$router.push('/home')
    }

    this.checkVerifyAccount()
    if( this.$store.getters[`${this.type}/transactionPayment`] == null ) {
      this.$router.push(`/zxcare`)
    }

    Object.assign(this.transactionProduct, this.$store.getters[`${this.type}/transactionProduct`])
    Object.assign(this.transactionPayment, this.$store.getters[`${this.type}/transactionPayment`])

    if(this.$route.query.t == 'zakat_fitrah') {
      this.isZafit = true
    }

    if(this.profile) {
      this.email = this.profile.email
      this.no_telp = this.profile.no_telp
    }
    
    this.fitur_id = this.transactionProduct.id
    this.getTypeTransaction()

    if(this.transactionProduct.names) {
      this.name =  this.transactionProduct.names
    }

    if(this.transactionProduct.mt !== null) {
      const sahabat = this.choiceMitra.slice(),
        find = sahabat.find(it => {
          if(it.user) {
            return it.user.id == this.transactionProduct.mt
          }
        })
      
      if(find) {
        this.sahabat = find
        this.sahabat_name = find.user ? find.user.name : find.name
      }
    }

  }
}
</script>